import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

interface Testimonial {
	name: string;
	function: string;
	quote: string;
	image: string;
}

const testimonials: Testimonial[] = [
	{
		name: "Arnold Leemhuis",
		function: "Carpenter, Roald Hans",
		quote: "Amazing earbuds with excellent sound quality. They fit perfectly and are very comfortable to wear. Highly recommended!",
		image: "/images/testimonials/testimonial-arnold.png",
	},
	{
		name: "Lars",
		function: "Technical Service, Hoekman Houtindustrie",
		quote: "I never want to be without these again. An excellent product.",
		image: "/images/testimonials/testimonial-lars.png",
	},
];

export default function Testimonials() {
	return (
		<section className="eo-quotes" data-theme="dark" aria-label="Testimonials">
			<Swiper
				modules={[Pagination, Autoplay]}
				slidesPerView={1}
				autoplay={{ pauseOnMouseEnter: true, delay: 10000 }}
				pagination={{ clickable: true, type: "bullets" }}
				loop={true}
			>
				{testimonials.map((t) => (
					<SwiperSlide key={t.name}>
						<figure className="eo-quote">
							<div className="eo-quote__text">
								<div className="eo-quote__inner">
									<span className="eo-quote__mark" aria-hidden="true">“</span>
									<blockquote className="eo-quote__body">{t.quote}</blockquote>
									<figcaption className="eo-quote__who">
										<strong>{t.name}</strong>
										<span>{t.function}</span>
									</figcaption>
								</div>
							</div>
							<img className="eo-quote__photo" src={t.image} alt={`${t.name} wearing EarsOnly earbuds`} loading="lazy" />
						</figure>
					</SwiperSlide>
				))}
			</Swiper>
		</section>
	);
}
